export const ServerAPI = {};

const SLICE = 'server';


ServerAPI.create = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/server`,
    method:   'POST',
    data:     data,
    slice:     SLICE,
    action:    'create',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

ServerAPI.delete = (ids, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/server`,
    method:    'DELETE',
    data:      {ids},
    slice:     SLICE,
    action:    'delete',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

ServerAPI.update = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/server`,
    method:   'PUT',
    data:     data,
    slice:     SLICE,
    action:    'update',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

ServerAPI.list = (data, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/servers`,
    method:    'GET',
    data:      data,
    slice:     SLICE,
    action:    'list',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

ServerAPI.item = (id, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/server`,
    method:    'GET',
    data:      {id},
    slice:     SLICE,
    action:    'item',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

ServerAPI.search = (name, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/servers`,
    method:    'POST',
    data:      {name},
    slice:     SLICE,
    action:    'search',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};
